import React from 'react';
import { TableRow } from '@material-ui/core';
import Seo from './seo';

function Abertura({ abertura, setAbertura }) {
  return (
    <>
      <TableRow>
        <Seo
          etapas="Mapeamento"
          status={abertura.mapeamento_status}
          setStatus={(data) =>
            setAbertura((prev) => ({ ...prev, mapeamento_status: data }))
          }
          encerramento={abertura.mapeamento_encerramento}
          setEncerramento={(data) =>
            setAbertura((prev) => ({ ...prev, mapeamento_encerramento: data }))
          }
          observacao={abertura.mapeamento_observacao}
          setObservacao={(data) =>
            setAbertura((prev) => ({ ...prev, mapeamento_observacao: data }))
          }
          observacao_interna={abertura.mapeamento_observacao_interna}
          setObservacaoInterna={(data) =>
            setAbertura((prev) => ({
              ...prev,
              mapeamento_observacao_interna: data,
            }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Elaboração Minuta Contratual"
          status={abertura.minuta_status}
          setStatus={(data) =>
            setAbertura((prev) => ({
              ...prev,
              minuta_status: data,
            }))
          }
          encerramento={abertura.minuta_encerramento}
          setEncerramento={(data) =>
            setAbertura((prev) => ({
              ...prev,
              minuta_encerramento: data,
            }))
          }
          observacao={abertura.minuta_observacao}
          setObservacao={(data) =>
            setAbertura((prev) => ({
              ...prev,
              minuta_observacao: data,
            }))
          }
          observacao_interna={abertura.minuta_observacao_interna}
          setObservacaoInterna={(data) =>
            setAbertura((prev) => ({
              ...prev,
              minuta_observacao_interna: data,
            }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Viabilidade"
          status={abertura.viabilidade_status}
          setStatus={(data) =>
            setAbertura((prev) => ({ ...prev, viabilidade_status: data }))
          }
          encerramento={abertura.viabilidade_encerramento}
          setEncerramento={(data) =>
            setAbertura((prev) => ({ ...prev, viabilidade_encerramento: data }))
          }
          observacao={abertura.viabilidade_observacao}
          setObservacao={(data) =>
            setAbertura((prev) => ({ ...prev, viabilidade_observacao: data }))
          }
          observacao_interna={abertura.viabilidade_observacao_interna}
          setObservacaoInterna={(data) =>
            setAbertura((prev) => ({
              ...prev,
              viabilidade_observacao_interna: data,
            }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="DBE"
          status={abertura.dbe_status}
          setStatus={(data) =>
            setAbertura((prev) => ({ ...prev, dbe_status: data }))
          }
          encerramento={abertura.dbe_encerramento}
          setEncerramento={(data) =>
            setAbertura((prev) => ({ ...prev, dbe_encerramento: data }))
          }
          observacao={abertura.dbe_observacao}
          setObservacao={(data) =>
            setAbertura((prev) => ({ ...prev, dbe_observacao: data }))
          }
          observacao_interna={abertura.dbe_observacao_interna}
          setObservacaoInterna={(data) =>
            setAbertura((prev) => ({
              ...prev,
              dbe_observacao_interna: data,
            }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Certificado Bird ID"
          status={abertura.certificado_status}
          setStatus={(data) =>
            setAbertura((prev) => ({ ...prev, certificado_status: data }))
          }
          encerramento={abertura.certificado_encerramento}
          setEncerramento={(data) =>
            setAbertura((prev) => ({ ...prev, certificado_encerramento: data }))
          }
          observacao={abertura.certificado_observacao}
          setObservacao={(data) =>
            setAbertura((prev) => ({ ...prev, certificado_observacao: data }))
          }
          observacao_interna={abertura.certificado_observacao_interna}
          setObservacaoInterna={(data) =>
            setAbertura((prev) => ({
              ...prev,
              certificado_observacao_interna: data,
            }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Registro"
          status={abertura.registro_status}
          setStatus={(data) =>
            setAbertura((prev) => ({ ...prev, registro_status: data }))
          }
          encerramento={abertura.registro_encerramento}
          setEncerramento={(data) =>
            setAbertura((prev) => ({ ...prev, registro_encerramento: data }))
          }
          observacao={abertura.registro_observacao}
          setObservacao={(data) =>
            setAbertura((prev) => ({ ...prev, registro_observacao: data }))
          }
          observacao_interna={abertura.registro_observacao_interna}
          setObservacaoInterna={(data) =>
            setAbertura((prev) => ({
              ...prev,
              registro_observacao_interna: data,
            }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Inscrição Municipal"
          status={abertura.inscricao_municipal_status}
          setStatus={(data) =>
            setAbertura((prev) => ({
              ...prev,
              inscricao_municipal_status: data,
            }))
          }
          encerramento={abertura.inscricao_municipal_encerramento}
          setEncerramento={(data) =>
            setAbertura((prev) => ({
              ...prev,
              inscricao_municipal_encerramento: data,
            }))
          }
          observacao={abertura.inscricao_municipal_observacao}
          setObservacao={(data) =>
            setAbertura((prev) => ({
              ...prev,
              inscricao_municipal_observacao: data,
            }))
          }
          observacao_interna={abertura.inscricao_municipal_observacao_interna}
          setObservacaoInterna={(data) =>
            setAbertura((prev) => ({
              ...prev,
              inscricao_municipal_observacao_interna: data,
            }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Deferimento Simples Nacional"
          status={abertura.deferimento_simples_status}
          setStatus={(data) =>
            setAbertura((prev) => ({
              ...prev,
              deferimento_simples_status: data,
            }))
          }
          encerramento={abertura.deferimento_simples_encerramento}
          setEncerramento={(data) =>
            setAbertura((prev) => ({
              ...prev,
              deferimento_simples_encerramento: data,
            }))
          }
          observacao={abertura.deferimento_simples_observacao}
          setObservacao={(data) =>
            setAbertura((prev) => ({
              ...prev,
              deferimento_simples_observacao: data,
            }))
          }
          observacao_interna={abertura.deferimento_simples_observacao_interna}
          setObservacaoInterna={(data) =>
            setAbertura((prev) => ({
              ...prev,
              deferimento_simples_observacao_interna: data,
            }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Licenciamento"
          status={abertura.licenciamento_status}
          setStatus={(data) =>
            setAbertura((prev) => ({ ...prev, licenciamento_status: data }))
          }
          encerramento={abertura.licenciamento_encerramento}
          setEncerramento={(data) =>
            setAbertura((prev) => ({
              ...prev,
              licenciamento_encerramento: data,
            }))
          }
          observacao={abertura.licenciamento_observacao}
          setObservacao={(data) =>
            setAbertura((prev) => ({ ...prev, licenciamento_observacao: data }))
          }
          observacao_interna={abertura.licenciamento_observacao_interna}
          setObservacaoInterna={(data) =>
            setAbertura((prev) => ({
              ...prev,
              licenciamento_observacao_interna: data,
            }))
          }
        />
      </TableRow>
    </>
  );
}

export default Abertura;
